const state = {
  userInfo: null,
}

const getters = {
}

const mutations = {
  setUserInfo (state, v) {
    state.userInfo = v
  }
}

const actions = {
  save ({ state, commit, rootState }, params) {
    return rootState.axios.post('/splice/v1frontend/splice-user/save', params)
  },
  view ({ state, commit, rootState }, params) {
    return rootState.axios.get('/splice/v1frontend/splice-user/view', { params }).then(res => {
      if (res.data.model) {
        if (res.data.model.suuid) {
          commit('setUserInfo', res.data.model)
        } else {
          commit('setUserInfo', null)
        }
      }
      return res
    })
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
